import { AutoAwesome } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { buildToolTooltip } from '~/components/toolbar/shared/toolTooltip';
import { useElastixRegistration } from '~/hooks/useElastixRegistration';

interface AutoRegisterToolProps {
    isDisabled: boolean;
    /**
     * Why the control is unavailable, appended to the tooltip while
     * disabled. Optional because an approved registration is visible in the
     * UI already.
     */
    disabledReason?: string;
    isOpen: boolean;
    onToggle: () => void;
}

export default function AutoRegisterTool({
    isDisabled,
    disabledReason,
    isOpen,
    onToggle,
}: AutoRegisterToolProps) {
    const { isSubmitting } = useElastixRegistration();
    const intl = useIntl();

    return (
        <ToolbarButton
            icon={
                isSubmitting ? (
                    <CircularProgress size={14} color="inherit" />
                ) : (
                    <AutoAwesome sx={{ fontSize: 14 }} />
                )
            }
            tooltip={buildToolTooltip(
                intl,
                intl.formatMessage({
                    id: 'workflow.imageRegistration.autoRegister',
                }),
                isDisabled ? disabledReason : undefined
            )}
            selected={isOpen}
            disabled={isDisabled}
            onClick={onToggle}
            data-testid="auto-register-tool"
        />
    );
}
